import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]




export default /*@__PURE__*/_defineComponent({
  __name: 'UndecidedIcon',
  props: {
  size: {
    type: Number,
    default: 60,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: `${__props.size}px`,
    height: `${__props.size}px`,
    viewBox: "0 0 648 600",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "undecided", -1),
    _createElementVNode("desc", null, "Created with Sketch.", -1),
    _createElementVNode("defs", null, null, -1),
    _createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "undecided",
        fill: "#000000",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("path", {
          d: "M329.270712,554.981974 C313.107811,557.873726 296.47642,559.436836 279.45462,559.436836 C228.857712,559.514991 179.275866,545.837784 135.940551,519.733858 C132.036468,517.46735 128.210468,515.200841 124.306385,512.934333 L58.2493107,530.988246 C40.1343683,535.91204 23.4248956,519.264926 28.4221211,501.132857 L46.3809002,435.091487 C39.6658785,423.680789 35.2152245,415.943398 33.0289384,411.723002 C11.2441585,371.082159 -0.0776805063,325.751988 0.000401142,279.718418 C0.000401142,125.205059 125.165283,0 279.45462,0 C420.313914,0 536.889815,104.337549 556.175982,240.01544 C613.253667,275.498023 648,338.022397 648,405.39241 C648,437.826928 640.035672,469.245426 625.043995,497.225084 C623.716607,499.726059 621.217995,504.024609 617.70432,510.120736 L628.791915,550.839734 C633.711058,568.971803 617.079667,585.697073 598.964725,580.695123 L558.128023,569.597047 L553.365042,572.410643 C523.225526,590.542712 488.713438,600.077679 453.498614,599.999523 C408.133177,600.077679 364.173209,584.133963 329.270712,554.981974 Z M389.940153,536.693595 C409.772891,546.306717 431.557671,551.308667 453.576696,551.308667 C479.968293,551.386823 505.813319,544.19652 528.456997,530.597468 C530.096711,529.581447 534.78161,526.924161 542.511693,522.391144 C548.133572,519.108615 554.848594,518.248904 561.173207,519.968325 L570.699168,522.547455 L568.122474,513.012488 C566.404678,506.681895 567.341657,499.88237 570.621087,494.255176 C574.603251,487.690117 578.429251,480.968746 582.177171,474.247376 C593.49901,453.067245 599.433215,429.386138 599.355133,405.39241 C599.355133,367.252541 584.51962,330.675783 557.893778,303.399525 C549.070552,408.362317 482.388824,496.834306 389.940153,536.693595 Z M95.9627468,437.983239 L86.4367858,472.840578 L121.261201,463.305611 C127.507733,461.586191 134.222754,462.445901 139.922715,465.72843 C151.478799,472.449801 158.428065,476.513885 160.848597,477.998839 C196.688073,499.491592 237.602857,510.824135 279.376539,510.74598 C406.88387,510.74598 510.263972,407.268141 510.263972,279.640262 C510.263972,152.012384 406.88387,48.6127007 279.376539,48.6127007 C151.869207,48.6127007 48.5671864,152.09054 48.5671864,279.718418 C48.5671864,318.327219 58.0150658,355.529221 75.8176816,388.745295 C78.160131,393.122001 84.0943363,403.438523 93.4641341,419.147772 C96.7435633,424.853121 97.6805431,431.574491 95.9627468,437.983239 Z M380.648436,194.528958 C394.07848,194.528958 404.931829,205.392568 404.931829,218.835309 C404.931829,232.278049 394.07848,243.141659 380.648436,243.141659 L178.182722,243.141659 C164.752679,243.141659 153.89933,232.278049 153.89933,218.835309 C153.89933,205.392568 164.752679,194.528958 178.182722,194.528958 L380.648436,194.528958 Z M283.436784,316.138866 C296.866828,316.138866 307.720177,327.002476 307.720177,340.445216 C307.720177,353.887956 296.866828,364.829722 283.436784,364.829722 L178.182722,364.829722 C164.752679,364.829722 153.89933,353.966112 153.89933,340.523372 C153.89933,327.080631 164.752679,316.217021 178.182722,316.217021 C178.182722,316.138866 283.436784,316.138866 283.436784,316.138866 Z",
          id: "Shape"
        })
      ])
    ], -1)
  ]), 8, _hoisted_1))
}
}

})